import { render, staticRenderFns } from "./header-widgets.vue?vue&type=template&id=d59f35ac"
import script from "./header-widgets.vue?vue&type=script&lang=js"
export * from "./header-widgets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports